/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Category_AllInputs */

const vi_agri_category_all = /** @type {(inputs: Agri_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả loại`)
};

/**

* @param {Agri_Category_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_category_all = /** @type {((inputs?: Agri_Category_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Category_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_category_all(inputs)
});